import Link from "next/link"
import { APP_B2B_ACCOUNT_OWNER, APP_B2B_OCI_ACCOUNT_OWNER, APP_B2B_OCI_USER } from "@/constants"

import { UserData } from "@/lib/intershop/interfaces/user/user"
import { resolveStoryblokStoryHref } from "@/lib/link-utils/storyblok-link-resolver"
import { getCountry, getIsoLocaleFromSbLocale } from "@/lib/locale/locale-common-utils"
import { cn } from "@/lib/utils"
import LucideIcon from "@/components/storyblok/common/LucideIcon"
import { UbHeaderStoryblok } from "@/components/storyblok/component-types"

import StoryblokLogoutButton from "./StoryblokLogoutButton"

export default function StoryblokAccountForm({
  blok,
  userData,
  sbLocale,
}: {
  blok: UbHeaderStoryblok
  userData: UserData
  sbLocale: string
}) {
  const country = getCountry(getIsoLocaleFromSbLocale(sbLocale))
  const userIsB2B = userData?.customerType === "SMB"
  const hasOCIUserRole = userData?.roleIds?.some((roleId: string) => roleId === APP_B2B_OCI_USER)
  const hasOCIAccountOwnerRole = userData?.roleIds?.some((roleId: string) => roleId === APP_B2B_OCI_ACCOUNT_OWNER)
  const hasB2BAccountOwnerRole =
    userIsB2B && userData?.roleIds?.some((roleId: string) => roleId === APP_B2B_ACCOUNT_OWNER)

  return (
    <ul role="list">
      <li className="text-lg font-bold">{userData?.lastName + ", " + userData?.firstName}</li>
      <li className="mb-2 border-b pb-2">{userData?.preferredInvoiceToAddress?.company}</li>

      {blok?.account_menu_links?.map((item) => (
        <li
          className={cn("", {
            hidden:
              (!userIsB2B && item.hideB2C) ||
              (userIsB2B && item.hideB2B) ||
              item.countries_exclude?.includes(country) ||
              (hasOCIUserRole && item.hideOCIUser) ||
              (hasOCIAccountOwnerRole && item.hideOCIAccountOwner) ||
              (!hasOCIAccountOwnerRole && item.showOCIAccountOwner) ||
              (!hasB2BAccountOwnerRole && item.showAccountOwner),
          })}
          key={item.title}
        >
          <Link
            prefetch={false}
            href={
              item.link.linktype === "story"
                ? resolveStoryblokStoryHref(item.link.cached_url, sbLocale, item.link.story)
                : item.link.cached_url
            }
            className="group flex gap-x-3 rounded-md py-2 leading-6 font-bold hover:text-primary-hover"
          >
            {item?.icon?.[0] && <LucideIcon blok={item.icon[0]} aria-hidden="true" />}
            {item.title}
          </Link>
        </li>
      ))}
      <li
        className={cn("", {
          hidden: hasOCIUserRole,
        })}
      >
        <StoryblokLogoutButton sbLocale={sbLocale} />
      </li>
    </ul>
  )
}
